import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {filter, map, take} from 'rxjs';
import {AuthenticationStateEnum} from '../enums/AuthenticationStateEnum';
import {UserSessionService} from '../services/user-session.service';

export const isLoggedInGuard: CanActivateFn = () => {
  const userSessionService = inject(UserSessionService);
  const router = inject(Router);

  return userSessionService.authState$.pipe(
    filter(state => state !== undefined),
    take(1),
    map(state => {
      if (state !== AuthenticationStateEnum.NOT_AUTHENTICATED) {
        return true;
      }

      router.navigate(['auth', 'login']).then();
      return false;
    }),
  );
};
